import { IconButton, Menu, MenuItem } from "@mui/material"
import { ProfileIcon } from "src/shared"
import React, { useCallback } from "react"
import { useAuthContext } from "src/hooks"

const ProfileButton = () => {
  const { handleLogout } = useAuthContext()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const onLogout = useCallback(() => {
    handleLogout()
  }, [handleLogout])

  return (
    <>
      <IconButton onClick={handleClick}>
        <ProfileIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{
          "& ul": {
            padding: 0,
            "& > li": {
              padding: "6px 12px",
              minHeight: "unset",
            },
          },
        }}
      >
        <MenuItem onClick={onLogout}>Đăng xuất</MenuItem>
      </Menu>
    </>
  )
}

export default ProfileButton
